export enum DocCodingResponsiveness {
	NotSpecified = 0,
	Responsive = 1,
	NonResponsive = 2,
	NeedsFurtherReview = 3
}
